/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_TitleInputs */

const vi_einvoice_credential_title = /** @type {(inputs: Einvoice_Credential_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản MISA của tôi`)
};

/**

* @param {Einvoice_Credential_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_title = /** @type {((inputs?: Einvoice_Credential_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_title(inputs)
});